import * as layoutConstants from '@appConstants';

import LayoutColor from './LayoutColor';
import LayoutTypes from './LayoutTypes';
import LayoutWidth from './LayoutWidth';
import LeftSideBarTheme from './LeftSideBarTheme';
import LeftSideBarType from './LeftSideBarType';
import useThemeCustomizer from './useThemeCustomizer';

function ThemeCustomizer() {
  const {
    layoutColor,
    layoutType,
    layoutWidth,
    leftSideBarType,
    leftSideBarTheme,
    disableLayoutWidth,
    disableSidebarTheme,
    disableSidebarType,
    changeLayoutType,
    changeLayoutColorScheme,
    changeWidthMode,
    changeLeftSidebarTheme,
    changeLeftSiderbarType,
    reset
  } = useThemeCustomizer();

  return (
    <div className="p-3">
      {/* Layouts */}
      <LayoutTypes
        changeLayoutType={changeLayoutType}
        layoutType={layoutType}
        layoutConstants={layoutConstants.LayoutTypes}
      />

      {/* color scheme */}
      <LayoutColor
        changeLayoutColorScheme={changeLayoutColorScheme}
        layoutColor={layoutColor}
        layoutConstants={layoutConstants.LayoutColor}
      />

      {/* Width */}
      {disableLayoutWidth && (
        <LayoutWidth
          changeWidthMode={changeWidthMode}
          layoutWidth={layoutWidth}
          layoutConstants={layoutConstants.LayoutWidth}
        />
      )}

      {/* Left Sidebar */}
      {disableSidebarTheme && (
        <LeftSideBarTheme
          changeLeftSidebarTheme={changeLeftSidebarTheme}
          leftSideBarTheme={leftSideBarTheme}
          layoutConstants={layoutConstants.SideBarTheme}
        />
      )}

      {/* Left Sidebar Size */}
      {disableSidebarType && (
        <LeftSideBarType
          changeLeftSiderbarType={changeLeftSiderbarType}
          leftSideBarType={leftSideBarType}
          layoutConstants={layoutConstants.SideBarType}
        />
      )}

      <div className="d-grid mt-4">
        <button className="btn btn-primary" id="resetBtn" type="button" onClick={() => reset()}>
          Reset to Default
        </button>
      </div>
    </div>
  );
}

export default ThemeCustomizer;
